module.exports = __webpack_public_path__ + "img/2.0c9f973e.png";